/* Value should be not more than 40 characters
* and use only lowercase letters, numbers, and underscore
* 'npce_' - No Parameters Custom event to be sent to GA by auto trigger in GTM
* 'ce-' - Custom event with parameters, need to create trigger+tag in GTM
* We will use regex to select events in GTM triggers
* */
/* cq_add - Custom Quote Create flow */
export enum CQuoteEvents {
   CreateSimplified = 'npce_cq_add_method_simple_quote',
   CreateCQuote = 'npce_cq_add_method_c_quote',
   CreateLaneSelect = 'npce_cq_add_lane_select',
   CreateLaneCreate = 'npce_cq_add_lane_create',
   CreateLaneEditClick = 'npce_cq_add_lane_edit_click',
   CreateLaneDetailEditClick = 'npce_cq_add_lane_detail_edit_click',
   CreateDeliveryOptionsEditClick = 'npce_cq_add_delivery_options_edit_click',
   CreateOfferSetupEditClick = 'npce_cq_add_offer_setup_edit_click',
   CreatePQTrue = 'npce_cq_add_pq_offer_flag_toggle_true',
   CreateGeneratePDFTrue = 'npce_cq_add_generate_pdf_toggle_true',
   CreateGeneratePDFFalse = 'npce_cq_add_generate_pdf_toggle_false',
   CreateSubmit = 'ce_cq_add_submit',
}

export enum Common {
    UserLogin = 'ce_user_login',
}
